module.exports = {
      id: "occasional_printing-usage",
      viewBox: "0 0 241.07 353.6",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#occasional_printing-usage",
      toString: function () {
        return this.url;
      }
    }